'use strict';

module.exports = {
  template: '<div>' + [
    '<tartan-preview-modal></tartan-preview-modal>',
    '<download-files-modal></download-files-modal>'
  ].join('') + '</div>',
  components: {
    tartanPreviewModal: require('./tartan-preview-modal'),
    downloadFilesModal: require('./download-files-modal')
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/components/application-modals/index.js
// module id = 170
// module chunks = 0